import React from 'react'
import { Calendar } from 'primereact/calendar'

import './CustomCalendar.css'

export default function CustomCalendar({
  label,
  value,
  onChange,
  marginTop = 10,
  disabled = false,
  ...props
}) {
  return (
    <div className="CustomCalendar" style={{ marginTop }}>
      <label className="calendar-label">{label}</label>
      <Calendar
        disabled={disabled}
        className="calendar-element"
        value={value}
        dateFormat="dd/mm/yy"
        onChange={event => onChange(event.target.value)}
        {...props}
      />
    </div>
  )
}
